// extracted by mini-css-extract-plugin
module.exports = {"row":"Project_row_1Lku8","col":"Project_col_3BSin"};